import { get, set } from 'lib/storage/isomorphicSessionStorage'

const TRIP_DETAILS_NUDGE_DISMISSED_KEY = 'tripPlanner:tripDetailsNudgeDismissed'

export function hasDismissedTripDetailsNudge(): boolean {
  return get(TRIP_DETAILS_NUDGE_DISMISSED_KEY) === true
}

export function markTripDetailsNudgeDismissed(): void {
  try {
    set(TRIP_DETAILS_NUDGE_DISMISSED_KEY, true)
  } catch {
    // Quota exceeded; best effort.
  }
}
